import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "./security/Authcontext";
import "./LoginPage.css";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLogin, setLogin] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const authContext = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();
    if (await authContext.login(username, password)) {
      navigate(`/welcome/${username}`);
    } else {
      setLogin(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="avatar-preview">
        {username ? username.charAt(0).toUpperCase() : "👤"}
        </div>    
        <h2>Welcome back</h2>
        <p className="subtitle">
          Don’t have an account?
          <button onClick={() => navigate("/signup")}>Create now</button>
        </p>

        {isLogin === false && (
          <div className="error-msg">Invalid credentials</div>
        )}
        

        <form onSubmit={handleSubmit}>
          <label>Username</label>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter username"
            required
          />

          <label>Password</label>
          <div className="password-box">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
            <span onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? "🙈" : "👁️"}
            </span>
          </div>

          <div className="row">
            <label>
              <input type="checkbox" /> Remember me
            </label>
            <button type="button" onClick={() => navigate("/forgot-password")}>
              Forgot password?
            </button>
          </div>

          <button className="submit-btn">Sign in</button>
        </form>
        <div className="login-divider">
  <span>or</span>
</div>
        <button type="button" className="login-google-btn">
        <span className="google-icon" aria-hidden="true"></span>
        Continue with Google
        </button>

        
      </div>
    </div>
  );
}
